import React from 'react';
import { BookOpenIcon, MoonIcon, HeartIcon, CoffeeIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const modules = [{
    icon: <BookOpenIcon className="h-6 w-6 text-white" data-id="element-196" />,
    title: 'El Manual Principal',
    description: 'La guía paso a paso para entender tu metabolismo después de los 35 y cómo reactivarlo.'
  }, {
    icon: <MoonIcon className="h-6 w-6 text-white" data-id="element-197" />,
    title: 'Protocolo Nocturno',
    description: 'La rutina exacta de 15 minutos antes de dormir para activar la quema de grasa nocturna.'
  }, {
    icon: <CoffeeIcon className="h-6 w-6 text-white" data-id="element-198" />,
    title: 'Guía de Alimentación Anti-Inflamatoria',
    description: 'Lista de compras y recetas sencillas con ingredientes que encuentras en cualquier supermercado de USA.'
  }, {
    icon: <HeartIcon className="h-6 w-6 text-white" data-id="element-199" />,
    title: 'Kit de Rescate de Estrés',
    description: 'Técnicas de respiración y ejercicios rápidos para bajar el cortisol en minutos cuando tienes un día difícil.'
  }];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-200">
      <div className="max-w-5xl mx-auto" data-id="element-201">
        <div className="text-center mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-heading" data-id="element-203">
            ¿Qué incluye "El Código"?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-204">
            Todo lo que necesitas para recuperar tu salud hormonal y metabólica.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-205">
          {modules.map((module, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 flex items-start" data-id="element-206">
              <div className="flex-shrink-0 h-12 w-12 rounded-lg bg-purple-600 flex items-center justify-center shadow-lg transform -rotate-3" data-id="element-207">
                {module.icon}
              </div>
              <div className="ml-6" data-id="element-208">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-209">
                  {module.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-210">
                  {module.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}